import LoadingButton from '@mui/lab/LoadingButton';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../Theme';

const LoadButton = (props) => <ThemeProvider theme={theme}>
    <LoadingButton variant="contained" {...props}/>
</ThemeProvider>;

export default LoadButton;
